import { render, staticRenderFns } from "./CoinStoreDetail.vue?vue&type=template&id=44763b08&scoped=true&"
import script from "./CoinStoreDetail.vue?vue&type=script&lang=ts&"
export * from "./CoinStoreDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStoreDetail.vue?vue&type=style&index=0&id=44763b08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44763b08",
  null
  
)

export default component.exports